import { Outlet, Link } from "react-router-dom";

import FixedPosition from "../components/FixedPosition";
import Menu from "../components/Menu";

const Layout = () =>
{

    return (
        <>
            <Outlet />
        </>
    )
};

export default Layout;